@import '../../stylesheets/mixins/common'

.mp-toast-area
  bottom 0
  display flex
  flex-direction column
  justify-content flex-end
  left 20px
  pointer-events none
  position fixed
  z-index $z-toast

  a
    color var(--inverted-component-text-color)
